import Box from "@mui/material/Box";
import { PageModuleData, PageModuleStatus } from "entities/pages/types";
import { groupModulesByMonth } from "modules/brands/utils";
import { FC } from "react";
import CollapsibleTable from "shared/components/CollapsibleTable";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { scheduleColumns, renderModuleRow } from "../../helpers";
import { usePageModulesFilter } from "./hooks/usePageModulesFilter";

type ModuleScheduleViewProps = {
  modules: PageModuleData[];
  isLoading: boolean;
  moduleDetailsDrawer: any;
  onUpdateStatus: (params: {
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
  brandId: string;
  modulePageTitle: string;
};

const ModuleScheduleView: FC<ModuleScheduleViewProps> = ({
  modules,
  isLoading,
  moduleDetailsDrawer,
  onUpdateStatus,
  brandId,
  modulePageTitle,
}) => {
  const { filtersData, filteredModules, searchValue, setSearchValue } =
    usePageModulesFilter(modules);

  const scheduledGroups = groupModulesByMonth(
    searchValue || filtersData.some((f) => f.selectedValue.length > 0)
      ? filteredModules
      : modules,
  );

  return (
    <>
      <FlexCenter
        marginBottom={"1rem"}
        gap="1rem"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        flexWrap="wrap"
      >
        <SearchField
          placeholder="Search..."
          value={searchValue}
          onChange={setSearchValue}
        />

        <Box display="flex" gap="1rem">
          {filtersData.map((filterProps) => (
            <Filter key={filterProps.title} {...filterProps} />
          ))}
        </Box>
      </FlexCenter>

      <CollapsibleTable
        columns={scheduleColumns}
        groups={scheduledGroups}
        renderRow={(module) =>
          renderModuleRow(
            brandId,
            modulePageTitle,
            module,
            moduleDetailsDrawer,
            onUpdateStatus,
          )
        }
        noDataMessage="No Results Found"
        maxHeight="340px"
        isLoading={isLoading}
      />
    </>
  );
};

export default ModuleScheduleView;
